import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 7.82 13",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.82 13\" id=\"icon-chevron-left\"><path d=\"M0,6.5,6.08,0,7.82,1.73,3.47,6.5l4.35,4.77L6.08,13Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-left.svg
// module id = 274
// module chunks = 0 1